const routeModule = {
    namespaced: true,
    state: () => ({
      previousRouteName: null,
    }),
    mutations: {
      setPreviousRouteName(state, name) {
        state.previousRouteName = name;
        localStorage.setItem('previousRoute', JSON.stringify(name));
      },
    },
    actions: {
      updatePreviousRouteName({ commit }, name) {
        commit('setPreviousRouteName', name);
      },
    },
    getters: {
      getPreviousRouteName(state) {
        if (state.previousRouteName) {
          return state.previousRouteName;
        }
        const storedRouteName = localStorage.getItem('previousRoute');
        return storedRouteName ? JSON.parse(storedRouteName) : null;
      },
    },
  };
  
  export default routeModule;
  